module.exports = __webpack_public_path__ + "static/media/student_icon.2b371edf.svg";